import React from 'react';

import TelegramIcon from '@ott/icon-telegram';
import OdnoklassnikiIcon from '@ott/icon-odnoklassniki';
import TwitterIcon from '@ott/icon-twitter';
import VkontakteIcon from '@ott/icon-vkontakte';
import YoutubeIcon from '@ott/icon-youtube';

import styles from './Socials.scss';

const SOCIAL_NETWORK_LIST = [
  {
    icon: <TelegramIcon className={styles.icon} />,
    link: 'https://t.me/OneTwoTrip',
  },
  {
    icon: <OdnoklassnikiIcon className={styles.icon} />,
    link: 'https://ok.ru/onetwotrip',
  },
  {
    icon: <TwitterIcon className={styles.icon} />,
    link: 'https://twitter.com/OneTwoTrip',
  },
  {
    icon: <VkontakteIcon className={styles.icon} />,
    link: 'https://vk.com/onetwotrip',
  },
  {
    icon: <YoutubeIcon className={styles.icon} />,
    link: 'https://www.youtube.com/OneTwoTripOfficial',
  },
];

const Socials = () => {
  const listNode = SOCIAL_NETWORK_LIST.map((item, index) => (
    <a
      key={index}
      target="_blank"
      rel="noopener noreferrer"
      href={item.link}
      className={styles.link}
    >
      {item.icon}
    </a>
  ));

  return <div className={styles.container}>{listNode}</div>;
};

export default Socials;
